import CONF from '@/config';
import store from "@/store/index";
import router from "@/routes";
import { utils } from '@/_oad_repo/utils';

//if use is registered forward user to the default app page
function frontAuth (to, from, next) {
    if (store.state.accessToken) {
        next(CONF.APP_DEFAULT_URL);
    } else {
        next();
    }
}

//if user is not registered forward user to the app login page
function backAuth (to, from, next) {
    if (!store.state.accessToken) {
        next(CONF.APP_LOGIN_URL);
    } else {
        next();
    }
}

function setAxiosToken(token) {
    store.commit('setAccessToken', token );
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}

function login(self) {
    self.loading = true;
    axios.post(CONF.APP_URL + '/login', self.form )
    .then(res => {

        if (res) {
            utils.c_notify(res.data.res, res.data.status);

            if (res.data.status == 'success') {
                setAxiosToken(res.data.token)
                store.commit('setUser', res.data.user );
                store.commit('setExpiration', res.data.expiration );
                if (store.state.redirectUrl) {
                    const url = store.state.redirectUrl
                    store.commit('setRedirectUrl', '')
                    router.push(url)
                } else {
                    router.push(CONF.APP_DEFAULT_URL)
                }

            } else if(res.data.status == 'warning' && res.data.action == 'verify') {
                router.push({
                    path: '/auth/verify_device',
                    query: {
                        id: res.data.id
                    }
                })
            }

        }

        self.loading = false;
    })
    .catch((error) => {
        console.log(error)
        utils.c_notify('Something went wrong. Please try again', 'warning');
        self.loading = false;
    })
}

function confirmLogout() {
    this.$utils.swalConfirm.fire({
        title: 'Logout?',
        text: '',
        showCancelButton: true,
        confirmButtonText: 'Confirm Logout'
    }).then((result) => {
        if (result.value) {
         logout()
        }
    })
}

function logout() {
    
    axios.get( CONF.APP_URL + '/logout')
    .then(res => {
        if (res.data.status == 'success') {

            store.commit('resetStorage','');
            if (router.currentRoute.name !== 'login') {
                router.push({ name: 'login' })
            }
        }
    })

}

function sendPasswordResetEmail(self) {
    self.loading = true;
    axios.post(CONF.APP_URL + '/resetPasswordSendEmail', self.form )
    .then(res => {

        utils.c_notify(res.data.res, res.data.status);

        if (res.data.status == 'success') {
            self.form.email = ''
        }
        
        self.loading = false;
    })
}

function resetPassword(self) {
    self.loading = true;
    axios.post(CONF.APP_URL + '/resetPasswordComplete', self.form )
    .then(res => {

        utils.c_notify(res.data.res, res.data.status);

        if (res.data.status == 'success') {
            self.form.password = '';
            self.form.password_confirm = '';
            setTimeout(() => self.$router.push(CONF.APP_LOGIN_URL), 1000)
        }
        
        self.loading = false;
    })
}

function verifyDevice(self) {
    const id = self.$route.query.id
    self.loading = true;
    axios.post(CONF.APP_URL + '/verifyDevice', {
        code: self.form.code,
        id,
    } )
      .then(res => {
          
          utils.c_notify(res.data.res, res.data.status);
          
          if (res.data.status == 'success') {
              setAxiosToken(res.data.token)
              store.commit('setUser', res.data.user );
              router.push(CONF.APP_DEFAULT_URL)
          }
          
          self.loading = false;
      })
}

export { frontAuth, backAuth, login, logout, confirmLogout, sendPasswordResetEmail, resetPassword, verifyDevice };